import React,{useEffect,useState} from 'react';
import {useSelector} from 'react-redux';
import {API} from 'src/config/constants';
import {RootState,store} from 'src/store';
import {getAuthSessionVersion} from 'src/store/auth/session';
import {logout} from 'src/store/auth/authSlice';
import {clearDisplaySettings,setDisplaySettings,DisplaySettings} from 'src/utils/date/displaySettings';

export function TerminalTimeGate({children}:{children:React.ReactNode}){
  const auth=useSelector((state:RootState)=>state.auth);
  const session=getAuthSessionVersion();
  const [ready,setReady]=useState<{owner:number;value:DisplaySettings}|null>(null);
  const [error,setError]=useState(''),[retry,setRetry]=useState(0);
  useEffect(()=>{
    let active=true;clearDisplaySettings();setReady(null);setError('');
    if(!auth.isAuthenticated)return;
    if(!auth.token){store.dispatch(logout());return;}
    const current=()=>active&&session===getAuthSessionVersion()&&auth.token===store.getState().auth.token;
    void fetch(`${API}v1/terminal-time/current`,{headers:{Authorization:`Bearer ${auth.token}`}}).then(async response=>{
      if(!current())return;
      if(response.status===401){store.dispatch(logout());return;}
      if(!response.ok)throw new Error('Не удалось проверить настройки времени терминала');
      const data=await response.json();if(!current())return;
      setDisplaySettings(data,session);setReady({owner:session,value:data});
    }).catch(()=>{if(current())setError('Не удалось проверить часовой пояс. Обновите данные перед продолжением.');});
    return()=>{active=false;};
  },[auth.token,auth.isAuthenticated,session,retry]);
  if(!auth.isAuthenticated)return <>{children}</>;
  if(!ready||ready.owner!==session)return <div role="status" style={{padding:24}}>{error||'Проверяем время терминала…'}{error&&<><button onClick={()=>setRetry(v=>v+1)}>Повторить</button><button onClick={()=>store.dispatch(logout())}>Выйти</button></>}</div>;
  return <><div style={{padding:'8px 16px',fontSize:12,color:'#475569'}}>{ready.value.terminal_name} · Время: {ready.value.time_zone} · {ready.value.hour_cycle==='h23'?'24 часа':'12 часов'}</div>{children}</>;
}
